<template>
    <a href="#" rel="noopener noreferrer" class="button primary" @click.prevent="handleRefund">
        Vrátenie tovaru
        <img src="/img/icons/btn-arrow-right.svg" v-svg-inline>
    </a>
</template>

<script>
import { inject } from 'vue'

export default {

    setup() {

        const emitter = inject('emitter')

        function handleRefund() {
            emitter.emit('refund-modal')
        }

        return {
            handleRefund
        }
    }
}
</script>
